import store from '@state/store';
import { useEffect, useState } from 'react';

import userActions from '@state/user/actions';
import createTokenProvider from './createTokenProvider';

const { dispatch } = store;

export const createAuthProvider = () => {

  const tokenProvider = createTokenProvider;

  const login = (newTokens, userData, isFirstTime = false) => {

    tokenProvider.setToken(newTokens, userData);
    dispatch(userActions.userUpdate(userData, isFirstTime));

  };

  const logout = () => {

    tokenProvider.setToken(null);
    dispatch(userActions.userLogout());

  };

  const useAuth = () => {

    const [isLogged, setIsLogged] = useState(tokenProvider.isLoggedIn());

    useEffect(() => {

      const listener = (newIsLogged) => {

        setIsLogged(newIsLogged);

      };

      tokenProvider.subscribe(listener);
      return () => {

        tokenProvider.unsubscribe(listener);

      };

    }, []);

    return [isLogged];

  };

  const getToken = async () => {

    const token = await tokenProvider.getToken();
    return token;

  };

  return {
    useAuth,
    login,
    logout,
    getToken,
  };

};

export default createAuthProvider();
